import { E_RouterNames } from "@/router/types";

export interface IBuildGasAlarmHistoryRouterParams {
    companyId: number
    areaId: number
    equipmentId: number
    mappingId?: number
    sensorId?: string
    createTime?: string
}

export function buildGasAlarmHistoryRouter(params: IBuildGasAlarmHistoryRouterParams) {
    return {
        name: E_RouterNames.gasAlarmHistory,
        query: params
    }
}
